import styles from "./CompleteTurkney.module.css";
import { ModuleType } from "@/lib/constants";
import { Lead } from "@/components/shared/lead/Lead";
import { useGlobalContext } from "@/lib/context";
import Image from "next/image";
import { ILandingPageData } from "@/interfaces/ILandingPage";

type props = {
    data: ILandingPageData['completeTurkney'];
}
export function CompleteTurkney({ data }: props) {
    const { props: { isMobileView } } = useGlobalContext();
    return (
        <section className={styles.completServicsminbox}>
            <div className={styles.completTueyleftim}>
                <Image width={348} height={155} className="img-responsive" src="/assets/images/completbgimg.svg" alt="" />
            </div>
            <div className="container1350">
                <div className={styles.completeyTurkmainb}>
                    <div className={styles.comPletinleftbox}>
                        <span>{data.headingText}</span>
                        {/* <p>With an emphasis on details,
                            extraordinary designs and
                            exceptional customer service,
                            we bring your dreams to life.</p> */}
                    </div>
                    <div className={styles.comPletturyrightm}>
                        {data.data.map((item, index) => {
                            return (
                                <div className={styles.completTuertiles} key={index}>
                                    <Image width={index == 0 ? 184 : index == 1 ? 166 : 117} height={160} className="img-responsive" src={'/assets/images/' + item.image} alt="" />
                                    <span>{item.heading}</span>
                                    <p>{item.subHeadingText}</p>
                                </div>
                            )
                        })}
                    </div>

                </div>
                <div className={styles.getFreeedtbt}>
                    <button className="btnPrimery" id="openExitIntentForm">{data.leadBtnText}</button>
                </div>
            </div>
            {
                isMobileView &&
                <div className={styles.completingLeadbox}>
                    <div className="leadForm bgWhite nextLeadForm ">
                        <Lead ModuleType={ModuleType.INTERIOR} Title="Every Home Has a Unique Inside Story,Meet the Designer" ButtonText={data.leadBtnText} />
                    </div>
                </div>
            }
        </section>
    )
}